var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenTeamwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_40",
    "data-name": "\\uADF8\\uB8F9 40",
    transform: "translate(-211 -542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_30",
    "data-name": "\\uD0C0\\uC6D0 30",
    transform: "translate(211 542)",
    fill: "rgba(17,17,53,0.27)",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_39",
    "data-name": "\\uADF8\\uB8F9 39",
    transform: "translate(-729.536 129.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-walking",
    "data-name": "Icon awesome-walking",
    d: "M18.359,8.554a4.277,4.277,0,1,0-4.237-4.277A4.258,4.258,0,0,0,18.359,8.554ZM26.7,21.839l-2.057-1.051-.856-2.62A9.635,9.635,0,0,0,14.767,11.4c-3.178-.009-4.934.9-8.235,2.245a8.451,8.451,0,0,0-4.387,4.116l-.591,1.212A2.873,2.873,0,0,0,2.806,22.8a2.775,2.775,0,0,0,3.751-1.274l.591-1.212a2.816,2.816,0,0,1,1.456-1.372l2.366-.962L9.629,23.389a5.761,5.761,0,0,0,1.315,5.239l5.287,5.827a5.767,5.767,0,0,1,1.315,2.468l1.615,6.531a2.828,2.828,0,0,0,3.425,2.076,2.858,2.858,0,0,0,2.057-3.457l-1.96-7.93a5.717,5.717,0,0,0-1.315-2.468l-4.016-4.428,1.518-6.121.485,1.47a5.668,5.668,0,0,0,2.8,3.3l2.057,1.051a2.775,2.775,0,0,0,3.751-1.274A2.9,2.9,0,0,0,26.7,21.839ZM6.5,34.375a5.534,5.534,0,0,1-1.253,1.916L.829,40.755a2.875,2.875,0,0,0,0,4.036,2.8,2.8,0,0,0,3.99,0L10.062,39.5a5.8,5.8,0,0,0,1.253-1.916l1.192-3.012C7.626,29.2,9.091,30.847,8.323,29.787L6.5,34.375Z",
    transform: "translate(948.284 426.039)",
    fill: "#d500fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-walking-2",
    "data-name": "Icon awesome-walking",
    d: "M18.359,8.554a4.277,4.277,0,1,0-4.237-4.277A4.258,4.258,0,0,0,18.359,8.554ZM26.7,21.839l-2.057-1.051-.856-2.62A9.635,9.635,0,0,0,14.767,11.4c-3.178-.009-4.934.9-8.235,2.245a8.451,8.451,0,0,0-4.387,4.116l-.591,1.212A2.873,2.873,0,0,0,2.806,22.8a2.775,2.775,0,0,0,3.751-1.274l.591-1.212a2.816,2.816,0,0,1,1.456-1.372l2.366-.962L9.629,23.389a5.761,5.761,0,0,0,1.315,5.239l5.287,5.827a5.767,5.767,0,0,1,1.315,2.468l1.615,6.531a2.828,2.828,0,0,0,3.425,2.076,2.858,2.858,0,0,0,2.057-3.457l-1.96-7.93a5.717,5.717,0,0,0-1.315-2.468l-4.016-4.428,1.518-6.121.485,1.47a5.668,5.668,0,0,0,2.8,3.3l2.057,1.051a2.775,2.775,0,0,0,3.751-1.274A2.9,2.9,0,0,0,26.7,21.839ZM6.5,34.375a5.534,5.534,0,0,1-1.253,1.916L.829,40.755a2.875,2.875,0,0,0,0,4.036,2.8,2.8,0,0,0,3.99,0L10.062,39.5a5.8,5.8,0,0,0,1.253-1.916l1.192-3.012C7.626,29.2,9.091,30.847,8.323,29.787L6.5,34.375Z",
    transform: "translate(962.409 426.039)",
    fill: "#efb800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-walking-3",
    "data-name": "Icon awesome-walking",
    d: "M18.359,8.554a4.277,4.277,0,1,0-4.237-4.277A4.258,4.258,0,0,0,18.359,8.554ZM26.7,21.839l-2.057-1.051-.856-2.62A9.635,9.635,0,0,0,14.767,11.4c-3.178-.009-4.934.9-8.235,2.245a8.451,8.451,0,0,0-4.387,4.116l-.591,1.212A2.873,2.873,0,0,0,2.806,22.8a2.775,2.775,0,0,0,3.751-1.274l.591-1.212a2.816,2.816,0,0,1,1.456-1.372l2.366-.962L9.629,23.389a5.761,5.761,0,0,0,1.315,5.239l5.287,5.827a5.767,5.767,0,0,1,1.315,2.468l1.615,6.531a2.828,2.828,0,0,0,3.425,2.076,2.858,2.858,0,0,0,2.057-3.457l-1.96-7.93a5.717,5.717,0,0,0-1.315-2.468l-4.016-4.428,1.518-6.121.485,1.47a5.668,5.668,0,0,0,2.8,3.3l2.057,1.051a2.775,2.775,0,0,0,3.751-1.274A2.9,2.9,0,0,0,26.7,21.839ZM6.5,34.375a5.534,5.534,0,0,1-1.253,1.916L.829,40.755a2.875,2.875,0,0,0,0,4.036,2.8,2.8,0,0,0,3.99,0L10.062,39.5a5.8,5.8,0,0,0,1.253-1.916l1.192-3.012C7.626,29.2,9.091,30.847,8.323,29.787L6.5,34.375Z",
    transform: "translate(976.534 426.039)",
    fill: "#108d00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenTeamwork);
export default __webpack_public_path__ + "static/media/ben_teamwork.6270307c1f3d90842f3ccd2fc322827a.svg";
export { ForwardRef as ReactComponent };